import { render } from "./SidebarMain.vue?vue&type=template&id=681d867a&scoped=true"
import script from "./SidebarMain.vue?vue&type=script&lang=js"
export * from "./SidebarMain.vue?vue&type=script&lang=js"

import "./SidebarMain.vue?vue&type=style&index=0&id=681d867a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681d867a"]])

export default __exports__